import React from 'react';

export const MetadataCard: React.FC<{ label: string; value: string }> = ({ label, value }) => (
    <div className="bg-white border rounded-lg p-3 shadow-sm hover:shadow transition-shadow">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">{label}</p>
        <p className="text-sm font-semibold text-gray-900 mt-1 truncate" title={value}>{value}</p>
    </div>
);
